import React, { useEffect, useState } from 'react';
import { measureCustomMetric } from '../../utils/webVitals';

const PerformanceMonitor = ({ children }) => {
  const [performanceMetrics, setPerformanceMetrics] = useState({
    fcp: null,
    lcp: null,
    cls: null,
    inp: null, // Updated from FID to INP (web-vitals v5)
    ttfb: null,
  });

  useEffect(() => {
    // Start measuring component mount time
    const mountMetric = measureCustomMetric('React.App.Mount');
    
    // Mark the end of mount
    const endMount = () => {
      mountMetric.end();
    };

    // Use requestIdleCallback for non-critical performance tracking
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(endMount);
    } else {
      setTimeout(endMount, 0);
    }

    // Listen for Web Vitals updates
    const handleWebVital = (metric) => {
      setPerformanceMetrics(prev => ({
        ...prev,
        [metric.name.toLowerCase()]: metric.value,
      }));
    };

    // Set up performance observer for layout shifts
    if ('PerformanceObserver' in window) {
      const observer = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        entries.forEach((entry) => {
          if (entry.entryType === 'layout-shift' && !entry.hadRecentInput) {
            console.log('Layout shift detected:', entry.value);
          }
        });
      });

      observer.observe({ entryTypes: ['layout-shift'] });

      return () => {
        observer.disconnect();
      };
    }
  }, []);

  // Only show performance info in development
  const showPerformanceInfo = process.env.NODE_ENV === 'development';

  return (
    <>
      {children}
      {showPerformanceInfo && (
        <div 
          style={{
            position: 'fixed',
            bottom: '10px',
            right: '10px',
            background: 'rgba(0, 0, 0, 0.8)',
            color: 'white',
            padding: '10px',
            borderRadius: '5px',
            fontSize: '12px',
            zIndex: 9999,
            fontFamily: 'monospace',
          }}
        >
          <div>Performance Metrics:</div>
          <div>FCP: {performanceMetrics.fcp ? `${Math.round(performanceMetrics.fcp)}ms` : 'N/A'}</div>
          <div>LCP: {performanceMetrics.lcp ? `${Math.round(performanceMetrics.lcp)}ms` : 'N/A'}</div>
          <div>CLS: {performanceMetrics.cls ? performanceMetrics.cls.toFixed(3) : 'N/A'}</div>
          <div>INP: {performanceMetrics.inp ? `${Math.round(performanceMetrics.inp)}ms` : 'N/A'}</div>
          <div>TTFB: {performanceMetrics.ttfb ? `${Math.round(performanceMetrics.ttfb)}ms` : 'N/A'}</div>
        </div>
      )}
    </>
  );
};

export default PerformanceMonitor;
